export class ServiceResponse<T>{
    Data: T;
    TotalCount: number;
    FilteredDataCount: number;
    ErrorMessages: string[];
}